import React from "react";

import {
  Button,
  Checkbox,
  message,
  Modal,
  Space,
  Table,
  Typography,
} from "antd";
import Text from "antd/lib/typography/Text";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteMerchantsField,
  deleteMerchantsField,
  getMerchantsField,
  UpdateMerchantsField,
  updateMerchantsField,
  AddMerchantsField,
} from "../../../../actions/companySettings";
import { employees } from "../../../../actions/employees";
import AddNewIcon from "../../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";
import { hasAccess, objectToFormData } from "../../../../utils";
import PageHeader from "../../../PageHeader";
import "./../../styles/setting.css";
import "./../Custom.css";
import AddMerchantField from "./AddMerchantsField";

const { Title } = Typography;

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  // {
  //   title: "Merchant Head",
  //   dataIndex: "user_name",
  //   key: "user_name",
  // },
];

message.config({
  maxCount: 3,
});

const Merchants = () => {
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setIsModalType] = React.useState("center");
  const [selectedId, setSelectedId] = React.useState("");
  const [merchantsFields, setMerchantsFields] = React.useState([]);
  const [employeesData, setemployeesData] = React.useState([]);

  const updateCompanySettingResponse = useSelector(
    (state) => state.companySetting.updateCompanySetting || {},
  );
  const merchantsFieldResponse = useSelector(
    (state) => state.companySetting.getMerchantsField || {},
  );
  const deleteMerchantsFieldResponse = useSelector(
    (state) => state.companySetting.deleteMerchantsField || {},
  );
  const addMerchantsFieldResponse = useSelector(
    (state) => state.companySetting.addMerchantsField || {},
  );
  const updateMerchantsFieldResponse = useSelector(
    (state) => state.companySetting.updateMerchantsField || {},
  );
  const employeesResponse = useSelector(
    (state) => state.employees.employees || {},
  );
  const {
    data: { response: { employees: employeesRecord = [] } = {} } = {},
    success = false,
  } = employeesResponse;

  React.useEffect(() => {
    // dispatch(companySetting({ show: 'id' }));
    dispatch(getMerchantsField({}));
    dispatch(employees(objectToFormData({ status: true })));
    // setIsModalVisible(false,);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (success) {
      setemployeesData(employeesRecord);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeesResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = false, errors = "" } = {},
    } = updateCompanySettingResponse;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateCompanySettingResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = updateMerchantsFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getMerchantsField({}));
      dispatch({
        type: UpdateMerchantsField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: UpdateMerchantsField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateMerchantsFieldResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = deleteMerchantsFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getMerchantsField({}));
      dispatch({
        type: DeleteMerchantsField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: DeleteMerchantsField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteMerchantsFieldResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = addMerchantsFieldResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getMerchantsField({}));
      dispatch({
        type: AddMerchantsField.RESET,
      });
    } else if (status === false && errors) {
      dispatch({
        type: AddMerchantsField.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addMerchantsFieldResponse]);

  React.useEffect(() => {
    const {
      data: {
        response: { transaction_merchants = [] } = {},
        status = false,
      } = {},
    } = merchantsFieldResponse;
    if (status) {
      setMerchantsFields(transaction_merchants);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantsFieldResponse]);

  const tableAction = [
    {
      title: "Enable",
      dataIndex: "enable",
      key: "enable",
      render: (enable, record) => (
        <Checkbox
          key={record.id}
          disabled={!hasAccess("merchants", "write")}
          onChange={(e) =>
            dispatch(
              updateMerchantsField(
                objectToFormData({ id: record.id, enable: e.target.checked }),
              ),
            )
          }
          defaultChecked={enable}
        ></Checkbox>
      ),
    },
    {
      title: "Actions",
      key: "action",
      render: (text, record) => (
        <Space key={record.id} size="middle">
          <button
            disabled={!hasAccess("merchants", "write")}
            onClick={() => showEditModal(record.id)}
          >
            <img src={EditIcon} alt={"logo"} className="action-logo" />
          </button>
          <button
            disabled={!hasAccess("merchants", "write")}
            onClick={() => showDeleteModal(record.id)}
          >
            <img src={DeleteIcon} alt={"logo"} className="action-logo" />
          </button>
        </Space>
      ),
    },
  ];

  const showModal = () => {
    setSelectedId("");
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showDeleteModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("center");
  };

  const showEditModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const renderDeleteOption = () => {
    return (
      <>
        <Text>
          If you delete this Merchant, the users will not no longer be
          associated to this Merchant. Are you sure you want to delete it?
        </Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          onClick={() =>
            dispatch(deleteMerchantsField(objectToFormData({ id: selectedId })))
          }
        >
          Delete
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  function handleButtonClick(e) {
    showModal();
  }

  return (
    <>
      <Modal
        title={
          modalType === "center" ? (
            <>
              <img src={DeleteIcon} alt={"logo"} className="action-logo" />{" "}
              Delete Merchant
            </>
          ) : (
            <Title level={4}>
              {selectedId ? "Edit Merchant" : "New Merchant"} &nbsp;
              <span className="text-small">Enter details and submit</span>
            </Title>
          )
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className={
          modalType === "center"
            ? "center-aligned-modal"
            : "right-alinged-modal-small"
        }
      >
        {modalType === "center" ? (
          renderDeleteOption()
        ) : (
          <AddMerchantField
            id={selectedId}
            handleCancel={handleCancel}
            employeesData={employeesData}
          />
        )}
      </Modal>
      <div className="heading-div">
        <PageHeader
          title={`Merchant`}
          navigation={{
            Home: "/dashboard/",

            Customisation: "/setting/customisation/",
            Merchant: null,
          }}
        />
      </div>
      {hasAccess("merchants", "write") && (
        <Button onClick={handleButtonClick} className="mb1 ml1 addNew">
          <img src={AddNewIcon} alt={"logo"} className="addNew-logo" />
          Add New
        </Button>
      )}
      <Table
        rowKey="id"
        columns={[...columns, ...tableAction]}
        dataSource={merchantsFields}
        pagination={{
          total: merchantsFieldResponse?.data?.total_records || 0,
          onChange: (pagee) => dispatch(getMerchantsField({ page: pagee })),
        }}
        className="settingsTable"
      />
    </>
  );
};

export default Merchants;

// merchants_prefix = 'rr',
// merchants_reminder = false,
// merchants_reminder_days = '10',
// merchants_starts_with = null,
